import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { filter } from 'rxjs/operators';
import { Icons } from '../../shared/helpers/icons';
import { NsideIdentityService } from '../../shared/services/auth/nSideIdentityService';
import { UserDataService } from '../../shared/services/auth/userData.service';

export type SidebarMode = 'large' | 'small';

const SIDEBAR_STORAGE_KEY = 'lockdown_management.sidebar_mode';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit {
  icons = Icons;
  pageRoute = '';

  @Input() mode: SidebarMode = 'large';
  @Output() modeChange = new EventEmitter<SidebarMode>();


  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private identity: NsideIdentityService,
    public userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.updatePageRoute());

    this.updatePageRoute();
  }

  navigateToPage(route: string): void {
    this.router.navigate(route ? ['/', route] : ['/']);
  }

  logout(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.identity.logout();
  }

  toggle(): void {
    const next: SidebarMode = this.mode === 'large' ? 'small' : 'large';
    this.mode = next;
    this.modeChange.emit(next);

    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(SIDEBAR_STORAGE_KEY, next);
    }
  }

  private updatePageRoute(): void {
    const path = this.router.url.split(/[?#]/)[0];
    this.pageRoute = path.split('/').filter(Boolean)[0] ?? '';
  }
}
